import styled, { css } from "styled-components";

export const InputDescriptionStyling = css`
  font-size: 0.75em;
  color: ${({ theme }) => theme.nafColor.signature.black};

  > p,
  > ul {
    line-height: 1.5;
    margin-top: 0;
    font-weight: lighter;
    letter-spacing: 0px;
  }
`;

const Description = styled.div`
  ${InputDescriptionStyling}
  margin-bottom: 10px;
`;

export function InputDescription({ description }: { description: string }) {
  if (!description) return null;
  return <Description dangerouslySetInnerHTML={{ __html: description }} />;
}
